import enCommon from './en_GB/translation.json'
import esCommon from './es_ES/translation.json'
import itCommon from './it_IT/translation.json'
import frCommon from './fr_FR/translation.json'

export const resources = {
  fr: {
    common: frCommon,
  },
  en: {
    common: enCommon,
  },
  es: {
    common: esCommon,
  },
  it: {
    common: itCommon,
  },
} as const
